import { TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
import { useHyperTable } from "../HyperTable";

interface HyperTableNoResultsProps<Entity> { }

export const HyperTableNoResults = <Entity extends any>(
  props: HyperTableNoResultsProps<Entity>,
) => {
  const { } = props;
  const { table, findResult } = useHyperTable<Entity>();

  if (findResult.isLoading || table.getRowModel().flatRows.length) return null;

  return (
    <TableRow className="table-row">
      <TableCell className="table-cell" colSpan={table.getFlatHeaders().length}>
        <Typography
          sx={{
            width: "100%",
            py: 2,
            px: 2,
            textAlign: "center",
          }}
        >
          {!findResult.isLoading &&
            !table.getRowModel().flatRows.length &&
            "לא נמצאו תוצאות."}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
